import { Box, Fade, Modal, Skeleton, Stack } from '@mui/material'
import { AlreadyAccount } from 'Components/Elements/SignUp/SignUp'
import storeAuth from 'GlobalStores/User/StoreAuth'
import { observer } from 'mobx-react-lite'
import { Suspense } from 'react' 
import Login from '../../Elements/Login/Login'
import { lazy } from 'react'
import pMinDelay from 'p-min-delay'
import storeCheckout from 'GlobalStores/Checkout/StoreCheckout'
import styled from '@emotion/styled'

const PreSummaryBoxLazyLoad = lazy(() => pMinDelay(import('../../Elements/Checkout/PreSummaryBoxes/Hongkong/PresummaryBox'), 0))

const HongkongCheckoutTheme = observer(({ Sections, step, onPlaceOrder, openLoginModal, setOpenLoginModal }) => {
    return (
        <>
            <Suspense fallback={<PageSkeletonSectionLazyLoad />}>
                <Stack minHeight={'300px'}>{Sections(step)}</Stack>
            </Suspense>
            <Stack>
                <Suspense fallback={<PageSkeletonSummaryElement />}>
                    <PreSummaryBoxLazyLoad step={step} edit={true} isReady={storeCheckout.isReadyToPlaceOrder} onPlaceOrder={onPlaceOrder} />
                </Suspense>
            </Stack>
            {step === 'create-account' && (
                <>
                    <DesktopAlreadyAccount>
                        <AlreadyAccount setOpenLoginModal={setOpenLoginModal} />
                    </DesktopAlreadyAccount>

                    <Modal
                        open={openLoginModal}
                        onClose={() => {
                            if (storeAuth.loadingLogin) return
                            setOpenLoginModal(false)
                        }}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description">
                        <Fade in={openLoginModal}>
                            <Box
                                sx={{
                                    position: 'absolute',
                                    top: 'calc(50% - 40px)',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    padding: '0px'
                                }}>
                                <Login showFooter={false} setOpenLoginModal={setOpenLoginModal} />
                            </Box>
                        </Fade>
                    </Modal>
                </>
            )}
        </>
    )
})

const PageSkeletonSummaryElement = () => {
    return (
        <Stack>
            <Skeleton
                variant="rounded"
                width={'100%'}
                sx={{
                    margin: '0',
                    borderRadius: '12px',
                    height: '370px',
                }}
            />
        </Stack>
    )
}

const PageSkeletonSectionLazyLoad = () => (
    <Stack>
        <Skeleton variant="rounded" width={'100%'} height={'700px'} sx={{ margin: '0', borderRadius: '12px' }} />
    </Stack>
)

const DesktopAlreadyAccount = styled('div')`
    display: block;
    @media screen and (min-width: 1200px) {
        display: none;
    }
`

export default HongkongCheckoutTheme
